// extracted by mini-css-extract-plugin
export default {"home":"styles_home__G+0Ts","btn":"styles_btn__vnxkj","welcome_svg":"styles_welcome_svg__M1CTp"};